import { type FC } from "react";

import { cx } from "@emotion/css";
import { Button, Spacing } from "@snapchat/snap-design-system";

import { Flexbox } from "../../../shared/components";
import { buttonDisabled } from "../../../shared/styles";

interface SidebarFooterButtonsProps {
    apply: () => void;
    applyLoading: boolean;
    onCancel: () => void;
    isDisabled?: boolean;
    dataTestIdPrefix?: string;
}

export const SidebarFooterButtons: FC<SidebarFooterButtonsProps> = ({
    applyLoading,
    apply,
    onCancel,
    isDisabled,
    dataTestIdPrefix = "",
}) => (
    <Flexbox justifyContent="flex-end" gap={`${Spacing.XS}px`}>
        <Button onClick={onCancel} isDisabled={applyLoading} data-testid={`sb-${dataTestIdPrefix}-cancel`}>
            Cancel
        </Button>
        <Button
            type="primary"
            onClick={apply}
            isPending={applyLoading}
            className={cx(isDisabled && buttonDisabled)}
            data-testid={`sb-${dataTestIdPrefix}-save`}
        >
            Apply
        </Button>
    </Flexbox>
);
